import * as React from "react";
import * as InputMask from "inputmask-core";
const { detect } = require('detect-browser');
const browser = detect();
const KEYCODE_Z = 90;
const KEYCODE_Y = 89;

function isUndo(e: any)
{
	return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
}

function isRedo(e: any)
{
	return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
}

export interface MaskedInputProps
{
	id: string;
	mask: string;
	formatCharacters?: any;
	placeholderChar?: string;
	value?: string;
	onChange?: (event: React.FormEvent<any>) => void;
	onBlue?: (event: React.FormEvent<any>) => void;
	size?: number;
	placeholder?: string;
	type?: string;
	name?: string;
	className?: string;
}

export class MaskedInput extends React.Component<MaskedInputProps, any>
{
	static defaultProps = {
		value: ""
	};
	mask: InputMask;
	input: HTMLInputElement;

	componentWillMount()
	{
		const options: any = {
			pattern: this.props.mask,
			value: this.props.value,
			formatCharacters: this.props.formatCharacters
		};
		if (this.props.placeholderChar)
		{
			options.placeholderChar = this.props.placeholderChar;
		}
		this.mask = new InputMask(options);
	}

	componentWillReceiveProps(nextProps: any)
	{
		if (this.props.value !== nextProps.value)
		{
			this.mask.setValue(nextProps.value);
		}
		if (this.props.mask !== nextProps.mask)
		{
			this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
		}
	}

	 private updateMaskSelection()
	 {		 
	 	this.mask.selection ={
			 start: this.input.selectionStart,
			 end : this.input.selectionEnd
		 }
	 }

	private updateInputSelection()
	 {
		 this.input.setSelectionRange(this.mask.selection.start,this.mask.selection.end);	 	
	 }

	private onChange(e: any)
	{
		const maskValue = this.mask.getValue();
		if (e.target.value !== maskValue)
		{
			// Cut or delete operations will have shortened the value
			if (e.target.value.length < maskValue.length)
			{
				const sizeDiff = maskValue.length - e.target.value.length;
				this.updateMaskSelection();
				this.mask.selection.end = this.mask.selection.start + sizeDiff;
				this.mask.backspace();
			}
			const value = this.getDisplayValue();
			e.target.value = value;
			if (value)
			{
				this.updateInputSelection();
			}
		}
		if (this.props.onChange)
		{
			this.props.onChange(e);
		}
	}

	private onKeyDown(e: any)
	{
		if (isUndo(e))
		{
			e.preventDefault();
			if (this.mask.undo())
			{
				e.target.value = this.getDisplayValue();
				this.updateInputSelection();

				this.onChange(e);
			}
			return;
		} else if (isRedo(e))
		{
			e.preventDefault();
			if (this.mask.redo())
			{
				e.target.value = this.getDisplayValue();
				this.updateInputSelection();

				this.onChange(e);
			}
			return;
		}

		if (e.key === "Backspace")
		{
			e.preventDefault();
			this.updateMaskSelection();
			if (this.mask.backspace())
			{
				const value = this.getDisplayValue();
				e.target.value = value;
				if (value)
				{
					this.updateInputSelection();
				}

				this.onChange(e);
			}
		}
	}

	private onKeyPress(e: any)
	{
		// Ignore modified key presses
		// Ignore enter key to allow form submission
		if (e.metaKey || e.altKey || e.ctrlKey || e.key === "Enter")
		{
			return;
		}

		e.preventDefault();
		this.updateMaskSelection();
		if (this.mask.input(e.key))
		{
			e.target.value = this.mask.getValue();
			this.updateInputSelection();

			this.onChange(e);
		}
	}

	private onPaste(e: any)
	{
		e.preventDefault();
		this.updateMaskSelection();
		// getData value needed for IE also works in FF & Chrome
		if (this.mask.paste(e.clipboardData.getData("Text")))
		{
			e.target.value = this.mask.getValue();
			// Timeout needed for IE
			setTimeout(this.updateInputSelection, 0);

			this.onChange(e);
		}
	}

	private getDisplayValue()
	{
		const value = this.mask.getValue();
		return value === this.mask.emptyValue ? "" : value;
	}

	render()
	{
		const { placeholder, type } = this.props;
		const patternLength = this.mask.pattern.length;
		if (browser && browser.name)
		{
			if( browser.name === "ie" && browser.version === "11.0.0")
			{
				return <input {...this.props}
						ref={(r: HTMLInputElement) => this.input = r }
						className={this.props.className}
						maxLength={patternLength}
						onInput={this.onChange.bind(this) }
						onKeyDown={this.onKeyDown.bind(this) }
						onKeyPress={this.onKeyPress.bind(this) }
						onPaste={this.onPaste.bind(this) }
						placeholder={placeholder || this.mask.emptyValue}
						type={type}
						value={this.getDisplayValue() }/>;
			}
		}
		return <input {...this.props}
				   ref={(r: HTMLInputElement) => this.input = r }
				   className={this.props.className}
				   maxLength={patternLength}
				   onChange={this.onChange.bind(this) }
				   onKeyDown={this.onKeyDown.bind(this) }
				   onKeyPress={this.onKeyPress.bind(this) }
				   onPaste={this.onPaste.bind(this) }
				   placeholder={placeholder || this.mask.emptyValue}
				   type={type}
				   value={this.getDisplayValue() }/>;
	}
}


// WEBPACK FOOTER //
// ./src/components/common/MaskedInput.tsx